// Подставляет {{name}}, {{event}}, {{date}} в шаблон
export const interpolate = (template, vars) =>
  (template || '').replace(/\{\{(\w+)\}\}/g, (_, k) => vars[k] ?? '');

const DEFAULT_BOOKING_SUBJECT = 'Вы записаны на {{event}}';
const DEFAULT_BOOKING_BODY =
`Здравствуйте, {{name}}!

Рады сообщить, что вы успешно записаны на мероприятие «{{event}}» {{date}}.

Если у вас возникнут вопросы — пишите нам:
✉️ julia@thesailingdoctor.ru

С уважением,
Команда The Sailing Doctor
thesailingdoctor.ru`;

// Загружает файл на сервер для прикрепления к письму, возвращает { url, name }
// (url вида /uploads/xxx — единственный формат, который принимает /api/booking/confirm)
export const uploadEmailAttachment = async (file) => {
  const token = sessionStorage.getItem('auth_token');
  const formData = new FormData();
  formData.append('file', file);
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch('/api/booking/upload-attachment', {
    method: 'POST',
    headers,
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return { url: data.url, name: data.name };
};

// Отправляет письмо-подтверждение через /api/booking/confirm
// Возвращает { ok: true } или { ok: false, error: '...' }
export const sendConfirmEmail = async ({ to, subject, body, attachments = [], vars = {} }) => {
  if (!to) return { ok: false, error: 'no email' };
  const resolvedSubject = subject || DEFAULT_BOOKING_SUBJECT;
  const resolvedBody    = body    || DEFAULT_BOOKING_BODY;
  const token = sessionStorage.getItem('auth_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  try {
    const res = await fetch('/api/booking/confirm', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        to,
        subject: interpolate(resolvedSubject, vars),
        body:    interpolate(resolvedBody,    vars),
        attachments,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { ok: false, error: data.error || `HTTP ${res.status}` };
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err.message };
  }
};
